import { useState } from "react";
import "@/App.css";
import { translations } from "@/i18n";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import AboutSection from "@/components/AboutSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import ProcessSection from "@/components/ProcessSection";
import CTASection from "@/components/CTASection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
  const [lang, setLang] = useState("en");
  const t = translations[lang];

  return (
    <div className="bg-[#050505] min-h-screen">
      <Header t={t} lang={lang} setLang={setLang} />
      <main>
        <HeroSection t={t} />
        <ServicesSection t={t} />
        <AboutSection t={t} />
        <WhyChooseUs t={t} />
        <ProcessSection t={t} />
        <CTASection t={t} />
        <ContactSection t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
